module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }